export default {
  data () {
    return {
      ver: '1.0.0'
    }
  },
  methods: {
    getId () {
      const randam = Math.floor(Math.random() * 1000)
      const date = new Date()
      const time = date.getTime()
      const id = randam + time.toString()
      return id
    },
    getTime () {
      const date = new Date()
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
    }
  }
}
